{
  "contacts": [
    {
      "contactName": "Hans Werner Mustermann",
      "contactPhone": "+49 89 123 456-76",
      "contactEmail": "mail@lorem.com",
      "contactLink": "https://www.claas.com/en-be/agricultural-machinery/product-configurator"
    },
    {
      "contactName": "Hans Werner Mustermann",
      "contactPhone": "+49 89 123 456-76",
      "contactEmail": "mail@lorem.com",
      "contactLink": "https://www.claas.com/en-be/agricultural-machinery/product-configurator"
    },
    {
      "contactName": "Hans Werner Mustermann",
      "contactPhone": "+49 89 123 456-76",
      "contactEmail": "mail@lorem.com",
      "contactLink": "https://www.claas.com/en-be/agricultural-machinery/product-configurator"
    }
  ]
}
